/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import PageBox from "./pageBox";
import profile from "../assets/img/dismantlers/profile-image.jpg";
import {ReactComponent as MapGreen} from "../assets/img/icons/map-green.svg";
import {ReactComponent as PhoneGreen} from "../assets/img/icons/phone-green.svg";
import {ReactComponent as PhoneWhite} from "../assets/img/icons/phone-white.svg";
import {ReactComponent as Facebook} from "../assets/img/social/facebook.svg";
import {ReactComponent as Instagram} from "../assets/img/social/instagram.svg";
import {ReactComponent as Twitter} from "../assets/img/social/twitter.svg";
import {Link, NavLink, useLocation, useParams} from "react-router-dom";
import { Outlet } from "react-router-dom";
import {ReactComponent as TimeGreen} from "../assets/img/icons/time-green.svg";
import {useTranslation} from "react-i18next";
import {ReactComponent as Mail} from "../assets/img/icons/send.svg";
import SEO from "../components/SEO";

const DismantlerLayout = (props) => {

    let params = useParams();
    const location = useLocation();

    const { t, i18n } = useTranslation();

    const [outletData, setOutletData] = React.useState({
        company: '',
        address : '',
        contact_choice: '',
        phone_code:'',
        phone : '',
        email: '',
        facebook : '',
        instagram : '',
        whatsup : '',
        schedule: [],
        logo: null
    });

    const data = {
        title: '',
        subtitle: ''
    };

    return (
        <PageBox data={data} dismantler={true}>
            <SEO
                title={t("meta_title.dismantler", { company: outletData?.company || "" })}
                description={t('meta_description.dismantler', {company: outletData.company})}
                image={outletData?.logo ?? null}
            />
            <div className='page-header'>
                <div className='DismantlerHeader'>
                    <div className='DismantlerHeader__share'>

                        <div className='shareLinks'>
                            <div className='shareLinks__label'>Share</div>
                            <ul className='shareLinks__list'>
                                <li className='shareLinks__item'><a href={`https://www.facebook.com/share.php?u=${window.location}`} target='_blank' rel='noopener'><Facebook/></a></li>
                                <li className='shareLinks__item'><a href={`https://twitter.com/intent/tweet?text=${params.companyname}&url=${window.location}`} target='_blank' rel='noopener'><Twitter/></a></li>
                                <li className='shareLinks__item'><a href={`mailto:?subject=${params.companyname}&body=Check out this ${window.location}`} target='_blank' rel='noopener'><Mail/></a></li>
                            </ul>
                        </div>

                    </div>
                    <div className='DismantlerHeader__row'>
                        <div className='DismantlerHeader__img'>
                            <div className='DismantlerHeader__img-wrap'>
                                {outletData.logo && <img src={outletData.logo} alt={params.companyname}/>}
                            </div>
                        </div>
                        <div className='DismantlerHeader__content'>
                            <div className='DismantlerHeader__title'>{outletData.company}</div>
                            <div className='DismantlerHeader__reviews'></div>
                            <div className='DismantlerHeader__info'>

                                <div className='icon-link'>
                                    <div className='icon-link__icon'><MapGreen/></div>
                                    <div className='icon-link__label small-text'>{outletData.address}</div>
                                </div>

                                <div className='icon-link'>
                                    <div className='icon-link__icon'><PhoneGreen/></div>
                                    <a href={`tel:+${outletData.phone_code}${outletData.phone}`} className='icon-link__label small-text'>{outletData.phone}</a>
                                </div>

                                <div className='icon-link icon-link--time'>
                                    <div className='icon-link__icon'><TimeGreen/></div>
                                    <div className='icon-link__label small-text'>{t('dismantlers.timeTable')}</div>

                                    <div className='icon-link__abs'>
                                        <div className='icon-link__label time-table-box'>
                                            <div className='row extra-small-gutters p-2'>
                                                <div className='col-sm-4'></div>
                                                <div className='col-sm-4'><span className='time-table-box__header'>{t('parts.MorningHours')} </span></div>
                                                <div className='col-sm-4'><span className='time-table-box__header'>{t('parts.EveningHours')} </span></div>
                                            </div>

                                            {
                                                outletData.schedule.map( (item, index) => (
                                                    <div className='row extra-small-gutters p-2' key={index}>
                                                        <div className='col-sm-4'><span className='time-table-box__label'>{item.description}:</span></div>
                                                        <div className='col-sm-4'><span className='time-table-box__label'>
                                                                {item.time_morning_from == '-1' ? (
                                                                    <>{t('parts.closed')}</>
                                                                ) : (
                                                                    <>{item.time_morning_from} - {item.time_morning_to}</>
                                                                )}

                                                            </span></div>
                                                        <div className='col-sm-4'><span className='time-table-box__label'>
                                                                {item.time_evening_from == '-1' ? (
                                                                    <>{t('parts.closed')}</>
                                                                ) : (
                                                                    <>{item.time_evening_from} - {item.time_evening_to}</>
                                                                )}

                                                            </span></div>
                                                    </div>
                                                ) )
                                            }
                                        </div>
                                    </div>

                                </div>


                                {outletData.contact_choice == 1 && <a href={`tel:+${outletData.phone_code}${outletData.phone}`} className='btn btn-primary btn-icon btn-icon-left btn--dismantlerCallUs' target='_blank' rel='noopener'><PhoneWhite/>{t('dismantlers.CallUs')}</a>}
                                {outletData.contact_choice == 2 && <a href={`mailto:${outletData.email}`} className='btn btn-primary btn-icon btn-icon-left btn--dismantlerCallUs' target='_blank' rel='noopener'><Mail/>Contact Us</a>}


                            </div>
                            <div className='ismantlerHeader__social'>

                                <ul className='socialLinks'>
                                    { outletData.facebook && <li className='socialLinks__item'><a href={outletData.facebook} target="_blank" rel="noopener"><Facebook/></a></li> }
                                    { outletData.instagram && <li className='socialLinks__item'><a href={outletData.instagram}><Instagram/></a></li> }
                                    {/*{ outletData.twitter && <li className='socialLinks__item'><a href={outletData.twitter}><Twitter/></a></li> }*/}
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='page-body'>
                <div className='DismantlerTabLinks'>
                    <NavLink to={`/${i18n.language}/mini-site/cars/${params.merchantid}/${params.companyname}`} className={`DismantlerTabLinks__item ${location.pathname.includes('/cars/') ? "active" : ""}`}>{t('dismantlers.cars')}</NavLink>
                    <NavLink to={`/${i18n.language}/mini-site/parts/${params.merchantid}/${params.companyname}`} className={`DismantlerTabLinks__item ${location.pathname.includes('/parts/') ? "active" : ""}`}>{t('dismantlers.Parts')}</NavLink>
                    <NavLink to={`/${i18n.language}/mini-site/company/${params.merchantid}/${params.companyname}`} className={`DismantlerTabLinks__item ${location.pathname.includes('/company/') ? "active" : ""}`}>{t('dismantlers.Company')}</NavLink>
                    <NavLink to={`/${i18n.language}/mini-site/gallery/${params.merchantid}/${params.companyname}`} className={`DismantlerTabLinks__item ${location.pathname.includes('/gallery/') ? "active" : ""}`}>{t('dismantlers.Gallery')}</NavLink>
                </div>

                <div className='DismantlerTabs'>
                    <Outlet context={[outletData, setOutletData]} />
                </div>
            </div>
        </PageBox>
    );
};

export default DismantlerLayout;
